<template>
	<div class="main">
		<section>
			<header class="page-title">
				<h2>{{ provider.name }} provider in articles</h2>
			</header>

			<div v-if="!loaded" class="flex center text-center mb-1">
				<i class="fas fa-cog fa-spin fa-2x"></i>
				Loading, please do not press anything...
			</div>

			<div class="table-reponsive" v-if="loaded">
				<table>
					<thead>
					<tr>
						<th>Article title</th>
						<th>Provider List name</th>
						<th>Rank in article</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="article in orderedProviderList" v-if="article.article_id !== 0">
						<td>
							<strong>{{ article.title }}</strong>
							<div class="article-links">
									<span class="badge badge-success" v-if="article.articleStatus === 'published' || article.articleStatus === 'hasDraft'"><i
											class="fas fa-check"></i> Published</span>
								<span class="badge badge-warning" v-if="article.articleStatus === 'draft' || article.articleStatus === 'hasDraft'"><i
										class="fas fa-exclamation-triangle"></i> {{ article.articleStatus }}</span>
								<span class="badge badge-danger" v-if="article.articleStatus === 'archived'"><i
										class="fas fa-times"></i> {{ article.articleStatus }}</span>
								<a :href="'/' + selectedSiteName + '/articles/' + article.article_id +'/edit/?tab=content'" title="Edit Article">Edit
									Article</a>
								<a v-if="article.articleStatus === 'published' && article.url !== ''" target="_blank"
								   :href="selectedSiteUrl + '/' + article.url" title="View Article">View Article</a>
							</div>
						</td>
						<td>
							<strong>{{ article.name }}</strong>
							<div class="article-links">
								<a :href="'/' + selectedSiteName + '/provider-lists/' + article.list_id +'/edit'" title="Edit Provider List">Edit
									Provider List</a>
							</div>
						</td>
						<td>{{ article.position }}</td>
					</tr>
					</tbody>
				</table>
			</div>
			<nav v-if="links">
				<ul class="pagination">
					<li aria-current="page" class="page-item" v-for="(link, index) in links" :class="[parseFloat(index) === activeLink ? 'active'  : '']">
						<span v-if="parseFloat(index) === activeLink" class="page-link">{{ index }}</span>
						<a v-if="parseFloat(index) !== activeLink" href="#" class="page-link" @click.prevent="loadPage(index)">{{ index }}</a>
					</li>
				</ul>
			</nav>
		</section>
	</div>
</template>

<script>
import {eventBus} from "../../app";

export default {
	props: {
		providerid: {
			type: Number
		}
	},
	data() {
		return {
			loaded: false,
			tabName: 'providerInArticles',
			providerId: this.providerid,
			provider: {},
			providerInArticles: {},
			selectedSiteName: this.$selectedSite.slug,
			selectedSiteUrl: this.$selectedSite.actualUrl,
			links: {},
			activeLink: 1
		}
	},
	created() {
		this.fetchDataFromApi();
	},
	computed: {
		orderedProviderList: function () {
			return _.orderBy(this.providerInArticles, ['position', 'title'], ['asc', 'asc'])
		}
	},
	methods: {
		fetchDataFromApi: function () {
			let vm = this;
			eventBus.$emit('onLoaderStart');
			axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId, {
				tab: vm.tabName
			})
				.then(response => {
					if (response.data.hasOwnProperty('provider')) {
						vm.provider = response.data.provider;
					} // if

					if (response.data.hasOwnProperty('providerInArticles')) {
						vm.providerInArticles = response.data.providerInArticles;
						vm.links = response.data.links;
					} // if

					eventBus.$emit('onLoaderFinish');
					vm.loaded = true;
				})
				.catch(e => {
					vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
				});
		},
		loadPage: function(index) {
			let vm = this;
			vm.providerInArticles = {};
			eventBus.$emit('onLoaderStart');
			vm.activeLink = parseFloat(index);
			vm.loaded = false;

			axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId + '?page=' + index, {
				tab: vm.tabName
			})
				.then(response => {
					if (response.data.hasOwnProperty('provider')) {
						vm.provider = response.data.provider;
					} // if

					if (response.data.hasOwnProperty('providerInArticles')) {
						vm.providerInArticles = response.data.providerInArticles;
						vm.links = response.data.links;
					} // if

					eventBus.$emit('onLoaderFinish');
					vm.loaded = true;
				})
				.catch(e => {
					vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
				});
		},
	}
}
</script>

<style scoped>

</style>
